import React, { useEffect } from 'react';

export function AdSense({ variant = 'default' }) {
  useEffect(() => {
    // Push the ad to Google AdSense
    if (window.adsbygoogle) {
      try {
        window.adsbygoogle.push({});
      } catch (error) {
        console.error('AdSense error:', error);
      }
    }
  }, []);

  // Variant 1: Fluid ad format (full-width responsive)
  if (variant === 'fluid') {
    return (
      <div className="ad-container my-4" style={{ minHeight: '100px', width: '100%' }}>
        <ins
          className="adsbygoogle"
          style={{
            display: 'block',
          }}
          data-ad-format="fluid"
          data-ad-layout-key="-ef+6l-2u-b0+uf"
          data-ad-client="ca-pub-7275329329758241"
          data-ad-slot="8782792973"
        ></ins>
      </div>
    );
  }

  // Variant 2: Auto-responsive ad (default)
  if (variant === 'responsive' || variant === 'default') {
    return (
      <div className="ad-container my-4" style={{ minHeight: '250px', width: '100%' }}>
        <ins
          className="adsbygoogle"
          style={{
            display: 'block',
          }}
          data-ad-client="ca-pub-7275329329758241"
          data-ad-slot="7358030666"
          data-ad-format="auto"
          data-full-width-responsive="true"
        ></ins>
      </div>
    );
  }

  return null;
}

export default AdSense;
